<template>
    <div
        class="dialogBox"
        :style="{background: isNative ? 'rgba(0, 0, 0, 0.68)' : 'rgba(0, 0, 0, 0.9)'}"
        @click.stop
    >

        <transition name="move">
            <red-packet
                v-show="isShow && dialogNum === 1"
                :dialog-data="dialogData"
                @listenToChildEvent="noticeFatherCloseLayer"
            />
        </transition>
        <transition name="move">
            <rules v-show="isShow && dialogNum === 2" @listenToChildEvent="noticeFatherCloseLayer"/>
        </transition>
    </div>
</template>

<script>
import RedPacket from './RedPacket';
import Rules from './Rules.vue';
import {getPlatInfo} from '@baidu/map-fe-utils';
let top = 0;

export default {
    props: {
        dialogNum: {
            type: Number,
            default: 0
        },
        dialogData: {
            type: null,
            default: null
        },
        lotteryNum: {
            type: Number,
            default: 0
        },
        isLogin: {
            type: Number,
            default: 0
        },
        factPrizeData: {
            type: null,
            default: null
        },
        statusType: {
            type: null,
            default: null
        },
        needHistory: {
            type: Boolean,
            default: () => false
        },
        isShow: {
            type: Boolean,
            default: () => false
        }
    },
    components: {
        RedPacket,
        Rules
    },
    data() {
        // 这里存放数据
        return {
            isNative: getPlatInfo().isNative,
            duwordData: '',
            cashNum: 0,
            // notice 带 btn数据
            typeData: 1
        };
    },
    mounted() {
        this.stopScroll(true); // 设置弹窗下页面不可滚动

        if (this.needHistory) {
            window.history.pushState('', document.title, '#modal');
        }
        if (window.history && window.history.pushState) {
            window.addEventListener('popstate', this.noticeFatherCloseLayer, false);
        }
    },
    methods: {
        // 关闭弹窗
        noticeFatherCloseLayer() {
            this.$parent.isShow = false;
            setTimeout(() => {
                this.$parent.closeDialogBox();
                this.stopScroll(false);
            }, 300);
        },
        jumpToPrizeCenter() {
            this.$parent.handleJumpPrize();
        },
        /**
         * 阻止页面滚动，用于弹窗开启
         */
        stopScroll(isFixed) {
            const bodyEl = document.body;
            if (isFixed) {
                top = window.scrollY;
                bodyEl.style.position = 'fixed';
                bodyEl.style.top = -top + 'px';
            }
            else {
                bodyEl.style.position = '';
                bodyEl.style.top = '';

                window.scrollTo(0, top); // 回到原先的top
            }
        },
        // 选择路线改变起始城市 ID
        changeStart(data) {
            this.$parent.startCity = data;
        },
        changeEnd(data) {
            this.$parent.endCity = data;
        },
        updataMain() {
            this.$parent.getMainData();
            this.$parent.reSet();
        },
        // 更新主页接口刷新抽奖剩余次数
        updataVideoNum() {
            this.$parent.getMainData();
        }
    },
    destroyed() {
        this.stopScroll(false);
    }
};
</script>
<style lang="scss" scoped>
.dialogBox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.68);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 500;

}
.move-enter-active,
.move-leave-active {
    transition: all .25s ease;
}

.move-enter {
    transform: translateX(130%);
}

.move-enter-to {
    transform: translateX(0%);
}

.move-leave-to {
    transform: translateX(-130%);
}
</style>
